// The custom cursor (.custom-cursor) that follows the pointer over the cards
// of the listings. The real cursor is hidden over a hover target; over an
// "intersector" (a card's tag panel) the custom one shrinks so the tags can
// be read.
//
// Pointer-only, so a touch viewport (500 px and under, as the site has always
// drawn the line) gets nothing. The hover handling is delegated to the
// container, so cards that arrive later through a Sprig request are covered
// without rebinding, and the document-level move listeners are on the page's
// signal and go with the page. The cursor element itself is looked up on each
// event, not once: it is rendered inside the Sprig component, so a search or a
// filter replaces it, and a reference taken at mount would move a detached node
// (the blog's "View" bubble gone after a search, the owner, 1 Nov).

const TOUCH_MAX_WIDTH = 500;

export function mountCursor({ root, signal }, hoverSelector, intersectorSelector) {
  if (document.documentElement.clientWidth <= TOUCH_MAX_WIDTH) return;
  if (!root.querySelector(".custom-cursor")) return;
  const cursorEl = () => root.querySelector(".custom-cursor");

  const move = (event) => {
    const cursor = cursorEl();
    if (!cursor) return;
    cursor.style.left = `${event.clientX}px`;
    cursor.style.top = `${event.clientY}px`;
  };
  document.addEventListener("mousemove", move, { signal });
  document.addEventListener("scroll", move, { signal });

  const over = (event) => {
    const cursor = cursorEl();
    if (!cursor) return;
    const target = event.target.closest(hoverSelector);
    if (target && root.contains(target)) {
      target.style.cursor = "none";
      cursor.classList.add("custom-cursor__is-hovering");
      cursor.classList.remove("custom-cursor__mouse-moves-out");
    }
    if (intersectorSelector && event.target.closest(intersectorSelector)) cursor.classList.add("custom-cursor__downsize");
  };
  const out = (event) => {
    const cursor = cursorEl();
    if (!cursor) return;
    if (event.target.closest(hoverSelector)) {
      cursor.classList.remove("custom-cursor__is-hovering");
      cursor.classList.add("custom-cursor__mouse-moves-out");
    }
    if (intersectorSelector && event.target.closest(intersectorSelector)) cursor.classList.remove("custom-cursor__downsize");
  };
  root.addEventListener("mouseover", over, { signal });
  root.addEventListener("mouseout", out, { signal });
}
